/**
 * AllReportsPage
 *
 * The default reports view: every report in the bibliographic sources
 * database, with the standard reports table (which includes its own toolbar
 * and pagination).
 */

import ReportsShell from "@/components/reports/ReportsShell"
import ReportsTable, { buildReportFilterOptions } from "@/components/reports/ReportsTable"
import { useReportsPage, ReportsPage } from "@/components/reports/useReportsPage"
import { FilterOption } from "@/components/shared/TableFiltersSelector"

/** Browser tab title and page heading. */
const PAGE_TITLE: string = "All Reports"

/** Short description shown under the page heading. */
const PAGE_DESCRIPTION: string = "Browse reports from the bibliographic sources database"

/**
 * The status filter options. They take no inputs, so they are built once at
 * module load rather than on every render.
 */
const FILTER_OPTIONS: FilterOption[] = buildReportFilterOptions()

/**
 * The All Reports page.
 *
 * @returns The rendered page element.
 */
export default function AllReportsPage(): React.JSX.Element {
  const page: ReportsPage = useReportsPage({ sidebarOption: "all-reports" })

  return (
    <ReportsShell title={PAGE_TITLE} description={PAGE_DESCRIPTION} showDetailsPanel>
      <ReportsTable page={page} filterOptions={FILTER_OPTIONS} visibleColumns={page.visibleColumns} />
    </ReportsShell>
  )
}
